"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var space_1 = require("./space");
/**
 * Convert a `string` to kebab case.
 */
function kebabCaseIt(str) {
    return space_1.spaceCaseIt(str).replace(/\s/g, "-");
}
exports.kebabCaseIt = kebabCaseIt;
